import { Languages } from 'helpers/enum'
import { getLanguageFromPath } from 'helpers/i18n'

type BasenameObject = {
    [key in Languages]: string
}

const language = getLanguageFromPath()

const createFullPath = (basenames: BasenameObject) =>
    `${location.origin}/${language}/${basenames[language]}`

const creatorBasenames: BasenameObject = {
    pl: 'kreator',
    en: 'creator',
    uk: 'creator',
}
const creatorAccommodationBasenames: BasenameObject = {
    pl: 'kreator-zakwaterowanie',
    en: 'creator-accommodation',
    uk: 'creator-accommodation',
}
const selfcareBasenames: BasenameObject = {
    pl: 'zarzadzaj-zamowieniem',
    en: 'manage-order',
    uk: 'manage-order',
}
const unlimitedBasenames: BasenameObject = {
    pl: 'karta-caloroczna',
    en: 'unlimited-card',
    uk: 'unlimited-card',
}
const unlimitedSummaries: BasenameObject = {
    pl: 'karta-caloroczna/podsumowanie',
    en: 'unlimited-card/summary',
    uk: 'unlimited-card/summary',
}
const unlimitedRenewBasenames: BasenameObject = {
    pl: 'odnow-karte',
    en: 'renew-card',
    uk: 'renew-card',
}
const unlimitedRenewSummaries: BasenameObject = {
    pl: 'odnow-karte/podsumowanie',
    en: 'renew-card/summary',
    uk: 'renew-card/summary',
}
const vouchersBasenames: BasenameObject = {
    pl: 'kreator-vouchery',
    en: 'vouchers-creator',
    uk: 'vouchers-creator',
}
const vouchersSummaries: BasenameObject = {
    pl: 'kreator-vouchery/podsumowanie',
    en: 'vouchers-creator/summary',
    uk: 'vouchers-creator/summary',
}
const vouchersOrders: BasenameObject = {
    pl: 'kreator-vouchery/zamowienie-i-platnosc',
    en: 'vouchers-creator/order_and_payment',
    uk: 'vouchers-creator/order_and_payment',
}

export const firstStep = createFullPath(creatorBasenames)

export const creatorAccommodationFirstStep = createFullPath(
    creatorAccommodationBasenames
)
export const selfcareFirstStep = createFullPath(selfcareBasenames)

export const unlimitedCardFirstStep = createFullPath(unlimitedBasenames)

export const unlimitedCardSummaryStep = createFullPath(unlimitedSummaries)

export const unlimitedRenewFirstStep = createFullPath(unlimitedRenewBasenames)

export const unlimitedRenewSummaryStep = createFullPath(unlimitedRenewSummaries)

export const vouchersFirstStep = createFullPath(vouchersBasenames)

export const vouchersSummaryStep = createFullPath(vouchersSummaries)

export const vouchersOrderStep = createFullPath(vouchersOrders)
